<template>
	<v-app id="app">
		<template v-if="$_app_stateAppIsInitialized() && $_app_stateUserIsInitialized()">
			<v-main id="_app_top" class="customVContent">
				<template v-if="!$_app_stateAppIsMobileScreen()">
					<setting-navigation-drawer />
				</template>
				<toolbar />
				<router-view />
				<toolbar-tabs />
			</v-main>
			<messagebar-footer />
			<template v-if="env.dev || env.qa">
				<env-info-system-bar />
			</template>
		</template>
		<template v-else>
			<v-row	class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
		<information-snackbar />
		<information-dialog />
	</v-app>
</template>

<script>
	import _ from 'lodash';

	export default {
		name: 'App',
		data() {
			return {
				apps_: [
					'languages', 
					'loginOptions', 
					'menuItems', 
					'menuGroups', 
					'themes', 
					'securityGroups' 
				],

				components_: [
					'adminRegisterUserForm',
					'adminResetPasswordForm',
					'adminSendNotificationForm',
					'chatList',
					'contactList',
					'menuList',
					'messagebarAnonymousForm',
					'messagebarAttachmentDialog',
					'messagebarChatDialog',
					'messagebarFooter',
					'messagebarTagDialog',
					'messagebarTitleDialog',
					'messagebarToDialog',
					'messagebarToDialog',
					'progressCircular',
					'progressLinear',
					'searchbarList',
					'settingList',
					'settingNavigationDrawer',
					'timelineMessageBodyCard',
					'timelineMessageHeaderCard',
					'toolbar',
					'toolbarTabs',
					'versionInfoFooter'
				]
			}
		},
		head: {
			title() {
				const self_ = this;
				const title_ = { inner: self_.appName }
				return title_
			}
		},
		computed: {
			// queries
			$_app_query() {
				const self_ = this;
				const route_ = self_.$route
				return route_.query
			},
			$_app_queryRefreshLocalStorage() {
				const self_ = this;
				const query_ = self_.$_app_query;
				if(self_.isFalse(query_)) { return null }
				return query_.refreshLocalStorage
			},
			$_app_queryRefreshCookies() {
				const self_ = this;
				const query_ = self_.$_app_query;
				if(self_.isFalse(query_)) { return null }
				return query_.refreshCookies
			},
			// current user
			$_app_currentUserUid() {
				const self_ = this;
				return () => {
					return self_.getCurrentUser('uid')
				}
			},
			// state
			$_app_stateAppIsInitialized() {
				const self_ = this;
				return () => {
					return self_.getAppState('isInitialized')
				}
			},
			$_app_stateAppIsMobileScreen() {
				const self_ = this;
				return () => {
					return self_.getAppState('isMobileScreen')
				}
			},
			$_app_stateUserIsInitialized() {
				const self_ = this;
				return () => {
					return self_.getUserState('isInitialized')
				}
			},
			$_app_stateUserId() {
				const self_ = this;
				return () => {
					return self_.getUserState('id')
				}
			},
			$_app_stateUserOldSystemClientUserId() {
				const self_ = this;
				return () => {
					return self_.getUserState('oldSystemClientUserId')
				}
			},
			$_app_stateUserUsername() {
				const self_ = this;
				return () => {
					return self_.getUserState('username')
				}
			}
		},
		created() { 
			const self_ = this;
			// life cycle
			self_.createdApp()
			// app initialization
			self_.$_app_initializeApp()
			// component initialization
			self_.$_app_initializeComponent()
			// local storage initialization
			self_.$_app_initializeLocalStorage()
			// firebase initialization & authentication
			self_.$_app_initFirebase()
			// one signal initialization
			self_.$_app_initOneSignal()
			// cookie
			self_.$_app_initCookie()
			// pwa install prompt
			self_.$_app_initPWA()
			// watch screen size changes
			self_.$_app_initScreenState()
		},
		updated () {
			const self_ = this;
			self_.$emit('update-head');
		},
		methods: {
			$_app_initializeApp() {
				const self_ = this;

				let promiseArray_ = []

				self_.apps_.forEach(appName => {
					promiseArray_.push(self_.initializeApp(appName))
				})

				Promise.resolve().then(() => {
					return Promise.all(promiseArray_)
				}).then(() => {
					// set app language
					self_.switchLanguage()
					// set app theme
					self_.switchTheme()
					// set menu group
					self_.switchMenuGroup()
					// initialized
					self_.setAppState('isInitialized', true)
				}).catch(error => {
/* dev */			self_.logDev('App Initialization', 'Failed to initialize app.', error)
				})
			},
			$_app_initializeComponent() {
				const self_ = this;

				let promiseArray_ = []

				self_.components_.forEach(componentName => {
					promiseArray_.push(self_.initializeComponent(componentName))
				})

				Promise.resolve().then(() => {
					return Promise.all(promiseArray_)
				}).then(() => {
					self_.setComponentState('isInitialized', true)
				}).catch(error => {
/* dev */			self_.logDev('Component Initialization', 'Failed to initialize component.', error)
				})
			},
			$_app_initializeLocalStorage() {
				const self_ = this;

				if(self_.checkLocalStorageVersion() && self_.$_app_queryRefreshLocalStorage != 1) { return }

				const types_ = [
					'langs',
					'styles'
				]

				let promiseArray_ = []

				types_.forEach(type => {
					promiseArray_.push(self_.initializeLocalStorage(type))
				})

				Promise.resolve().then(() => {
					return Promise.all(promiseArray_)
				}).then(() => {
					self_.setLocalStorage('version', self_.appVersion)

					// custom bri life start
					self_.setLocalStorage('customBriLifeLotteryDialog', {})
					// custom bri life end
				}).catch(error => {
/* dev */			self_.logDev('Local Storage Initialization', 'Failed to initialize local storage.', error)
				})
			},
			$_app_initFirebase() {
				const self_ = this;

				self_.firebase.initializeApp(self_.firebaseConfig)
				self_.firebase.auth().setPersistence(self_.firebase.auth.Auth.Persistence.LOCAL)
				self_.firebase.auth().languageCode = 'en';
				self_.firebase.auth().onAuthStateChanged(self_.$_app_updateAuth)
				if (self_.firebase.auth().isSignInWithEmailLink(window.location.href)) { self_.verifyEmailLink() }
			},
			$_app_updateAuth(user) {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.$_app_initializeUser(user)
				}).then(() => {
					// send one signal tag
					self_.$_app_oneSignalSendTag()
				}).catch(error => {
/* dev */			self_.logDev('Auth Update', 'Failed to update authentication', { user: user, error: error })
				})
			},
			$_app_initializeUser(user) {
				const self_ = this;

				self_.setUserState('isInitialized', false)

				// non user
				if(self_.isEmpty(user)) { 
					self_.setUserState('username', null)
					self_.setUserState('fullName', null)
					self_.setUserState('email', null)
					self_.setUserState('phone', null)
					self_.setUserState('postcode', null)
					self_.setUserState('address1', null)
					self_.setUserState('address2', null)
					self_.setUserState('profilePictureUrl', null)
					self_.setUserState('userGroupCode', null)
					self_.setUserState('userGroupName', null)
					self_.setUserState('securityGroupCode', null)
					self_.setUserState('securityGroupName', null)
					self_.setUserState('blocked', false)
					self_.setUserState('disabled', false)

					self_.setUserState('isInitialized', true)

					return Promise.resolve()
				}
				// user
				else {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.initializeUser()
						}).then(() => {
							// only for clients using old system
							const oldSystemClientUserId_ = self_.$_app_stateUserOldSystemClientUserId()

							if(self_.isFalse(oldSystemClientUserId_)) {
								return self_.$_app_updateOldSystemClientId()
							} else {
								return Promise.resolve()
							}
						}).then(() => {
							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}
			},
			$_app_updateOldSystemClientId() {
				const self_ = this;

				const uid_ = self_.$_app_currentUserUid()
				const username_ = self_.$_app_stateUserUsername()

/* dev */		self_.logDev('App', 'Update old system client user id: started...', { uid: uid_, username: username_ })

				let ipcUserId_ = null;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipcGetClientUsers(username_)
					}).then(result => {
						if(self_.isEmpty(result)) {
							reject('No ipc user exists.')
						} else {
							ipcUserId_ = result[0]['id']
							return self_.ipCliUpdateAppUsers(uid_, { oldSystemClientUserId: ipcUserId_ })
						}
					}).then(() => {
/* dev */				self_.logDev('App', 'Update old system client user id: finished...', { uid: uid_, username: username_, ipcUserId: ipcUserId_ })

						resolve()
					}).catch(error => {
/* dev */				self_.logDev('App', 'Update old system client user id: error...', { error: error })

						reject(error)
					})
				})
			},
			$_app_oneSignalSendTag() {
				const self_ = this;
				// target uid & group
				const uid_ = self_.$_app_currentUserUid()
				// tag
				const tag_ = {
					uid: uid_
				}
				// send tag
				self_.oneSignalSendTag(tag_)
			},
			$_app_initOneSignal() {
				const self_ = this;
				self_.initOneSignal()
			},
			$_app_initCookie() {
				const self_ = this;
				// refresh
				if(self_.$_app_queryRefreshCookies == 1) {
					self_.removeCookie('appSessionId')
					self_.removeCookie('language')
					self_.removeCookie('menuGroup')
					self_.removeCookie('theme')
				}
				// get current session id
				const id_ = self_.getCookie('appSessionId')
				// set new session id
				if(self_.isFalse(id_)) {
					const new_ = self_.getChanceSessionId();
					self_.setCookie('appSessionId', new_)
				}
			},
			$_app_initPWA() {
				const self_ = this;
				if(self_.env.release) { window.addEventListener('beforeinstallprompt', self_.beforeInstallPrompt) }
			},
			$_app_initScreenState() {
				const self_ = this;
				window.addEventListener('resize', self_.$_app_setScreenState)
				self_.$_app_setScreenState()
			},
			$_app_setScreenState: _.debounce(function() {
				this.setAppState('screenWidth', window.innerWidth)
				this.setAppState('screenHeight', window.innerHeight)
				this.setAppState('isMobileScreen', window.matchMedia('(max-width: 960px)').matches)
			},300)
		}
	}
</script>

<style scoped>
</style>

<style>
	/* content */
	.customVContent {
		padding-bottom: 0 !important;
	}

	/* grid */
	.customVContainer {
		padding-top: 0 !important;

		background-position: center center !important;
		background-attachment: fixed !important;
		background-size: cover !important;
	}
	@media screen and (min-width:960px) {
		.customVContainer {
			padding-left: calc( ( 100vw - 900px) / 2 ) !important;
			padding-right: calc( ( 100vw - 900px ) / 2 ) !important;

			padding-bottom: 24px !important;
			min-height: calc( 100vh - 64px ) !important;
		}
	}
	@media screen and (min-width: 1264px) {
		.customVContainer {
			padding-left: calc( ( 100vw - 1185px ) / 2 ) !important;
			padding-right: calc( ( 100vw - 1185px ) / 2 ) !important;

			padding-bottom: 24px !important;
			min-height: calc( 100vh - 64px ) !important;
		}
	}
	@media screen and (max-width:959px) {
		.customVContainer {
			padding-bottom: 0 !important;
			min-height: calc( 100vh - 56px ) !important;
		}
	}
	.customVContainer.fluid {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}
	.customVRow {
		padding-top: 24px !important;
	}
	@media screen and (min-width:960px) {
		.customVRow {
			min-height: calc( 100vh - 88px ) !important;
		}
	}
	@media screen and (max-width:959px) {
		.customVRow {
			min-height: calc( 100vh - 56px ) !important;
		}
	}

	/* alert */
	.customVAlert {
		border-radius: 4px !important;
		margin-bottom: 0 !important;
	}

	/* banner */
	.customVBanner .v-banner__wrapper {
		padding: 0 24px !important;
	}
	.customVBanner .v-banner__text {
		width: 100% !important;
	}

	/* button (for tile) */
	.customVBtn {
		border-radius: 4px !important;
	}
	.customVBtn.theme--dark.v-btn.v-btn--disabled {
		color: #ffffff99 !important;
	}
	.customVBtn.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
		background-color: #C3C3C399 !important;
	}

	/* card */
	.customVCard {
		padding: 0 12px !important;
		border-radius: 4px !important;
	}

	/* image */
	.customVImg {
		border-radius: 4px !important;
	}

	/* list */
	.customVList {
		background-color: transparent !important;
	}
	.customVList .v-list__group--active:before {
		display: none !important;
	}
	.customVList .v-list-group__header {
		margin-bottom: 8px;
	}
	.customVListItem {
		padding-left: 16px !important;
		margin-bottom: 8px !important;
	}
	.customVList.v-list__group:before{
		display: none !important;
	}
	.customVListItemIcon {
		margin-right: 24px !important;
	}

	/* sheet */
	.customVSheet {
		border-radius: 4px !important;
	}

	/* input (for messagebar footer) */
	.customVInput .v-input__append-outer {
		margin-top: 10px !important;
		margin-bottom: 10px !important;
	}

	/* Common Classes */
	.center {
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
	}
	.start {
		display: flex !important;
		align-items: center !important;
		justify-content: flex-start !important;
	}
	.end {
		display: flex !important;
		align-items: center !important;
		justify-content: flex-end !important;
	}
	.center.column {		
		flex-direction: column !important;
	}
	.noDisplay {
		display: none !important;
	}
	.overflowHidden {
		overflow: hidden !important;
	}

	/* footer bug fix */
	.v-footer--fixed {
		position: fixed !important;
	}

	/* remove scroll bar */
	::-webkit-scrollbar {
		display: none !important;
	}

	/* remove border bottom from banner */
	.v-banner__wrapper {
		border: none !important;
	}

	/* remove margin left from tab */
	.customVTabs.v-tabs {
		min-width: 150px !important;
		height: calc( 100% + 24px ) !important;
		margin-bottom: -24px !important;
	}
	.customVTabs .v-tab {
		min-width: 150px !important;
		margin-left: 0 !important;
		padding-left: 24px !important;
		padding-right: 24px !important;
	}
	.customVTabs.v-tabs-items {
		background-color: transparent !important;
	}

	/* for textarea on messagebar footer */
	.customVTextarea.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
		margin-top: 14px !important;
	}

	.customVTextField .v-label {
		font-size: .75rem !important;
	} 
	.customVTextField input {
		font-size: .75rem !important;
	}

	/* for video*/
	.video-js .vjs-tech {
		border-radius: 4px 4px 0 0 !important;
	}
	.video-js .vjs-poster {
		border-radius: 4px 4px 0 0 !important;
	}
	.customVideo {
		user-select: none;
		background-color: transparent !important;
	}

	/* for calendar */
	.customVCalendar {
		height: calc( 100vh - 198px ) !important;
	}
	.customVCalendar.v-calendar-weekly .v-calendar-weekly__day {
		border-right: none !important;
	}
	.customVCalendar.v-calendar-weekly .v-calendar-weekly__head-weekday {
		border-right: none !important;
	}
	.customVCalendar .v-calendar-weekly__day-label {
		margin: 4px 0 !important;
	}
	.customVCalendar .v-btn__content {
		width: 100% !important;
	}
	.customVCalendar .customVCalendarButtonText {
		text-align: left !important;
		overflow: hidden !important;
		text-overflow: ellipsis !important;
		white-space: nowrap !important;
	}

	/* for system bar */
	.customVSystemBar {
		min-height: 30px !important;
		position: fixed !important;
		top: calc( 100vh - 30px ) !important;
	}

	/* for app bar */
	.customVAppBar .v-toolbar__content {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}
</style>
